(function () {
  const CHEVRON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function bindExclusiveAccordion(container) {
    const items = container.querySelectorAll('.magic-tabs__details');

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) {
          return;
        }

        items.forEach(function (other) {
          if (other !== item) {
            other.open = false;
          }
        });
      });
    });
  }

  function createAccordionItem(title, bodyHtml) {
    const details = document.createElement('details');
    details.className = 'magic-tabs__details';

    const summary = document.createElement('summary');
    summary.className = 'magic-tabs__summary';

    const titleEl = document.createElement('span');
    titleEl.className = 'magic-tabs__summary-text';
    titleEl.textContent = title;

    const iconEl = document.createElement('span');
    iconEl.className = 'magic-tabs__summary-icon';
    iconEl.innerHTML = CHEVRON_SVG;

    summary.appendChild(titleEl);
    summary.appendChild(iconEl);

    const panel = document.createElement('div');
    panel.className = 'magic-tabs__panel xo-content rte';
    panel.innerHTML = bodyHtml;

    details.appendChild(summary);
    details.appendChild(panel);
    return details;
  }

  function splitByHeading(html, tagName) {
    const tag = String(tagName || 'h2').toLowerCase();
    const doc = new DOMParser().parseFromString('<div id="magic-tabs-root"></div>', 'text/html');
    const root = doc.getElementById('magic-tabs-root');
    root.innerHTML = html;

    const intro = doc.createElement('div');
    const sections = [];
    let current = null;
    let target = intro;

    root.childNodes.forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === tag) {
        if (current) {
          sections.push(current);
        }
        current = {
          title: node.textContent.replace(/\s+/g, ' ').trim(),
          body: doc.createElement('div'),
        };
        target = current.body;
        return;
      }

      target.appendChild(node.cloneNode(true));
    });

    if (current) {
      sections.push(current);
    }

    return { intro: intro, sections: sections };
  }

  function initMagicTabs(container) {
    if (!container || container.dataset.magicTabsReady === 'true') {
      return;
    }

    const root = container.closest('[data-magic-tabs-root]');
    const source = root && root.querySelector('.magic-tabs__source');
    if (!source) {
      return;
    }

    const delimiter = container.dataset.delimiter || 'h2';
    const html = source.innerHTML.trim();
    container.innerHTML = '';

    if (!html) {
      container.dataset.magicTabsReady = 'true';
      return;
    }

    const parsed = splitByHeading(html, delimiter);
    const fragment = document.createDocumentFragment();
    const introText = parsed.intro.textContent.replace(/\s+/g, ' ').trim();

    if (introText) {
      fragment.appendChild(createAccordionItem('Description', parsed.intro.innerHTML));
    }

    parsed.sections.forEach(function (section) {
      const bodyText = section.body.textContent.replace(/\s+/g, ' ').trim();
      if (!section.title && !bodyText) {
        return;
      }
      fragment.appendChild(
        createAccordionItem(section.title || 'Details', section.body.innerHTML)
      );
    });

    if (!fragment.childNodes.length) {
      fragment.appendChild(createAccordionItem('Description', html));
    }

    container.appendChild(fragment);
    bindExclusiveAccordion(container);
    container.dataset.magicTabsReady = 'true';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-magic-tabs]').forEach(initMagicTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
